import { type PropsWithChildren } from "react";
import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./InputLabelRightV2.styled";
import { Typography } from "../Typography";

export type InputLabelRightV2Props = PropsWithChildren<{
  label?: string;
}>;

function InputLabelRightV2(props: InputLabelRightV2Props) {
  const { label, children } = props;

  const { tokens } = useDesignTokens();
  const { inputLabelRight } = tokens;

  return (
    <S.Container>
      <S.InputWrapper $label={label}>{children}</S.InputWrapper>

      {label && (
        <S.LabelWrapper>
          <Typography
            component="span"
            color="inherit"
            variant={inputLabelRight.label.typography.variant}
            fontFamily={inputLabelRight.label.typography.fontFamily}
          >
            {label}
          </Typography>
        </S.LabelWrapper>
      )}
    </S.Container>
  );
}

export default InputLabelRightV2;
